<template>
    <div class="fullscreen bg_report">
        <div class="menu" @click="showFullSwiper">
        </div>
        <header class="flex_center">
            <div class="flex_align">
                <div class="logo--company">
                    <div class="pic">
                        <img :src="logo" alt="logo">
                    </div>
                </div>
                <p class="title ml_15">我的业绩报告</p>
            </div>
            <div class="year_select_box">
                <el-select v-model="currentYear" popper-class="zfyx_select_dropdown" @change="changeYear"
                    placeholder="请选择">
                    <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </header>

        <div class="main flex_justify_between">
            <div class="main--left">
                <div class="box_normal h_left_top subscript right_bottom left_top mb_15">
                    <div class="box_unit_title mb_15">
                        我的战略伙伴开工建面
                        <div class="unit">({{ partnerBuildData.Header }})</div>
                    </div>
                    <Loading v-if="parBuildLoading" class="partnerMain_left"></Loading>
                    <template v-else>
                        <div class="progressbarList partnerMain_left mt_5"
                            v-if="partnerBuildData && partnerBuildData.aList">
                            <ScrollBox :num='partnerBuildData.aList.length'>
                                <ul slot="main">
                                    <li class="item" v-for="(item, index) in partnerBuildData.aList" :key="index">
                                        <div class="label">{{ item.sCompany }}</div>
                                        <div class="valueBar flex_align">
                                            <div class="innerBar blue"
                                                :style="{ 'width': item.TotalBuildArea_ / partnerBuildData.AllArea * 100 + '%' }">
                                                <div class="innerSplit"></div>
                                            </div>
                                        </div>
                                        <div class="value">
                                            {{ item.TotalBuildArea }}
                                        </div>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                        <Empty v-else></Empty>
                    </template>
                </div>
                <div class="box_normal h_left_bottom subscript right_bottom left_top">
                    <div class="box_news_title">百强房企战略合作占比</div>
                    <div class="box_chart--drop">
                        <Loading v-if="coverLoading"></Loading>
                        <Echarts v-else :options="getOptions('drop', companyPartnerCoverData)"></Echarts>
                    </div>
                </div>
            </div>
            <div class="main--middle">
                <div class="box_chart--doubleLine mb_20">
                    <Loading v-if="countMoneyLoading" :isMask="true"></Loading>
                    <div class="detailBox">
                        <div class="item">
                            <p class="label">{{ currentYear }}年企业中标项目数量({{ countMoneyHead.sProjectHeader }})</p>
                            <p>
                                <span class="value c_reportcount">{{ countMoneyHead.iCounts }}</span>
                                <span class="ratio">同比 {{ countMoneyHead.sProjectRate }}</span>
                                <i class="iconfont icon-iconfont_up"
                                    :class="{ 'icon-iconfont_down1': countMoneyHead.iCountType == '2' }">
                                </i>
                            </p>
                        </div>
                        <div class="item">
                            <p class="label">{{ currentYear }}年企业中标项目销售额({{ countMoneyHead.sBidHeader }})</p>
                            <p>
                                <span class="value c_reportmoney">{{ countMoneyHead.BidAmount }}</span>
                                <span class="ratio">同比 {{ countMoneyHead.sBidRate }}</span>
                                <i class="iconfont icon-iconfont_up"
                                    :class="{ 'icon-iconfont_down1': countMoneyHead.iAmountType == '2' }">
                                </i>
                            </p>
                        </div>
                    </div>
                    <div class="chartsBox">
                        <Echarts :options="getOptions('base', lineBarchartsData)"></Echarts>
                    </div>
                </div>
                <div class="box_map">
                    <Loading v-if="spreadLoading" :isMask="true"></Loading>
                    <!-- 地图 -->
                    <div class="map-content" ref="myMap"></div>

                    <div class="mapTitle">{{ currentYear }}年企业中标项目分布</div>
                    <div class="hotmapList">
                        <div class="item head mb_10">
                            <span>城市</span>
                            <span>项目数</span>
                        </div>
                        <div class="hotmapList_main" v-if="companyHomeSpreadData && companyHomeSpreadData.length">
                            <ScrollBox :autoplay='false'>
                                <ul slot="main">
                                    <li class="item" :class="{ 'active': activeCity == item.CityCaption }"
                                        v-for="(item, index) in companyHomeSpreadData" :key="index"
                                        @click="onHotmap(item)">
                                        <span>{{ item.CityName }}</span>
                                        <span>{{ item.count }}</span>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                        <!-- <ul class="hotmapList_main">
                            <li class="item" v-for="(item,index) in projectSpreadData" :key="index">
                                <span>{{item.CityCaption}}</span>
                                <span>{{item.count}}</span>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div class="main--right">
                <div class="box_normal special h_right_top subscript right_bottom left_top mb_15">
                    <div class="box_unit_title mb_15">{{ currentYear }}年度落地合作项目占比 TOP10</div>
                    <Loading v-if="parProjectLoading"></Loading>
                    <template v-else>
                        <ul v-if="partnerProjectData && partnerProjectData.aList"
                            class="progressbarList partnerMain_right mt_5">
                            <li class="item" v-for="(item, index) in partnerProjectData.aList" :key="index">
                                <div class="label">{{ item.companyName }}</div>
                                <div class="valueBar flex_align">
                                    <div class="innerBar orange"
                                        :style="{ 'width': !Number(item.iThisCoverCnt) ? '0' : (item.iThisCoverCnt / maxProjectValue * 100) + '%' }">
                                    </div>
                                    {{ item.iThisCoverCnt }}
                                </div>
                                <div class="value">
                                    {{ item.iRange }}
                                    <i class="iconfont" :class="{
                                        'icon-iconfont_up': item.iRangeType == 1,
                                        'icon-iconfont_down1': item.iRangeType == 2,
                                    }"></i>
                                </div>
                            </li>
                        </ul>
                        <Empty v-else></Empty>
                    </template>
                </div>
                <div class="box_normal h_right_bottom subscript right_bottom left_top">
                    <div class="box_news_title">战略合作伙伴动态</div>
                    <Loading v-if="newsLoading"></Loading>
                    <template v-else>
                        <Empty v-if="!partnerNewListCount"></Empty>
                        <template v-else>
                            <swiper class="box_partner_wrap" :options="swiperOption" ref="swiperOption">
                                <!-- slides -->
                                <swiper-slide v-for="(list, index) in partnerNewList" :key="index">
                                    <div class="box_partner c_pointer" @click="toNewsDetail(list.StrokeNewsId)">
                                        <div class="item">
                                            <p class="title">{{ list.title }}</p>
                                            <p class="con">{{ list.content }}</p>
                                            <div class="footer flex_justify_between mt_20">
                                                <button class="tipBtn">{{ list.companyName }}</button>
                                                <p class="c_999">{{ list.date }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="box_partner_footer">
                                <i class="el-icon-arrow-left icon_l" id="arrowL"></i>
                                共{{ partnerNewListCount }}条
                                <i class="el-icon-arrow-right icon_r" id="arrowR"></i>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Echarts from "@/components/Echarts";
import getCharts from "@/utils/getCharts.js";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ajaxService from '@/server/api.js'
import chartSet from "@/config/chartSet";
import { createMaps, drawHotmap } from "@/utils/mapCommon.js";
import permission from "@/mixins/permission.js";
import Empty from "@/components/Empty";
import Loading from "@/components/Loading";

import Util from "@/utils/Util.js"

export default {
    mixins: [permission],
    data() {
        return {
            map: null,
            view: null, // MapVGL 视图实例
            heatmapLayer: null, // 热力图层
            cityMarkers: [], // 有数据城市的高亮标记数组
            allCityBoundaries: [], // 全国所有城市边界数组
            partnerBuildData: {},//获取合作伙伴的开工建面排行
            partnerProjectData: {},//获取公司合作伙伴落地项目前10
            companyHomeSpreadData: [],//企业中标分布（热力图）
            companyPartnerCoverData: {},//百强房企合作占比（水滴图）
            countMoneyHead: {},//当年企业中标项目数量，销售额 还有环比（折柱图-头部）
            countMoneyChart: [],//当年企业中标项目数量，销售额 还有环比（折柱图-图表）
            partnerNewList: [],//合作伙伴动态列表
            partnerNewListCount: 0,//合作伙伴动态列表 数量
            swiperOption: {//合作伙伴动态列表 swiper 配置
                navigation: {
                    nextEl: '#arrowR',
                    prevEl: '#arrowL',
                    disabledClass: 'disabled',
                },
                slidesPerView: 1,
                slidesPerColumn: 2,
                autoplay: {
                    delay: 3000,
                    // stopOnLastSlide: false,
                    // disableOnInteraction: true,
                },
            },
            activeCity: '',
            logo: '',
            currentYear: '',
            parBuildLoading: false, // 我的战略伙伴开工建面
            parProjectLoading: false, // 落地合作项目占比 TOP10
            countMoneyLoading: false, // 企业中标项目数量&销售额
            coverLoading: false, // 百强房企战略合作占比
            newsLoading: false, // 战略合作伙伴动态
            spreadLoading: false, // 企业中标项目分布-热力学图
            maxProjectValue: 0,
            useTestData: false // 控制是否使用测试数据：true=使用测试数据，false=使用真实接口
        }
    },
    components: {
        Echarts,
        swiper,
        swiperSlide,
        Empty,
        Loading
    },
    computed: {
        lineBarchartsData() {//折柱图data
            let obj = {
                xAxisData: [],
                barObj: {
                    name: this.currentYear + '年企业中标项目数量',
                    data: [],
                    unit: this.countMoneyHead.sProjectHeader
                },
                lineObj: {
                    name: this.currentYear + '年企业中标项目销售额',
                    data: [],
                    unit: this.countMoneyHead.sBidHeader
                },
            }
            if (this.countMoneyChart && this.countMoneyChart.length) {
                this.countMoneyChart.forEach(item => {
                    obj.xAxisData.push(item.sCateDesc)
                    obj.barObj.data.push(item.iCnt)
                    obj.lineObj.data.push(item.BidAmount)
                })
            }
            return chartSet.reportLineBarChart(obj)
        },
        yearOptions() {
            const curYear = Util.getFullYear() || ''
            const tempArr = new Array(3).fill(curYear).map((item, idx) => item = item - idx)
            let yearArr = tempArr.map(item => {
                return { value: item, label: item }
            })
            return yearArr
        }
    },
    mounted() {
        this.currentYear = Util.getFullYear()
        // this.currentYear = this.currentYear - 1;

        this.waitForBMapLib().then(() => {
            this.initMap()
            this.getInitData()//获取数据
        })
        document.title = "我的业绩报告 - 优采大数据"
    },
    methods: {
        waitForBMapLib() {
            return new Promise((resolve) => {
                if (typeof mapvgl !== 'undefined') {
                    resolve();
                } else {
                    const checkInterval = setInterval(() => {
                        if (typeof mapvgl !== 'undefined') {
                            clearInterval(checkInterval);
                            resolve();
                        }
                    }, 100);
                    // 设置超时，避免无限等待
                    setTimeout(() => {
                        clearInterval(checkInterval);
                        console.error('mapvgl 加载超时');
                        resolve(); // 即使超时也resolve，避免阻塞
                    }, 10000);
                }
            });
        },
        initMap() {
            let el = this.$refs.myMap;
            //创建地图
            this.map = createMaps(el, [116.418261, 39.921984], 5, 'report');
            // 创建 MapVGL 视图实例
            if (typeof mapvgl !== 'undefined') {
                this.view = new mapvgl.View({
                    map: this.map
                });
                console.log('MapVGL view initialized');
            } else {
                console.error('mapvgl is not available');
            }

            // 初始化时显示全国主要城市的行政边界
            this.drawAllCityBoundaries();
        },
        // 绘制全国省级行政边界
        drawAllCityBoundaries() {
            // 全国34个省级行政区
            const provinces = [
                '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
                '辽宁省', '吉林省', '黑龙江省',
                '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
                '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省',
                '重庆市', '四川省', '贵州省', '云南省', '西藏自治区',
                '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区',
                '台湾省', '香港特别行政区', '澳门特别行政区'
            ];

            console.log(`🗺️ 开始绘制全国 ${provinces.length} 个省级行政区的边界`);

            provinces.forEach(provinceName => {
                const boundary = new BMapGL.Boundary();
                boundary.get(provinceName, (rs) => {
                    if (rs.boundaries && rs.boundaries.length > 0) {
                        const boundaries = rs.boundaries;

                        for (let i = 0; i < boundaries.length; i++) {
                            const points = [];
                            const coords = boundaries[i].split(';');

                            coords.forEach(coord => {
                                if (coord) {
                                    const [lng, lat] = coord.split(',').map(Number);
                                    if (!isNaN(lng) && !isNaN(lat)) {
                                        points.push(new BMapGL.Point(lng, lat));
                                    }
                                }
                            });

                            if (points.length > 0) {
                                // 创建省级边界多边形 - 灰色边界
                                const polygon = new BMapGL.Polygon(points, {
                                    strokeColor: '#4A5568',
                                    strokeWeight: 1,
                                    strokeOpacity: 0.5,
                                    fillColor: 'transparent',
                                    fillOpacity: 0
                                });

                                this.map.addOverlay(polygon);

                                // 保存到全局边界数组
                                if (!this.allCityBoundaries) {
                                    this.allCityBoundaries = [];
                                }
                                this.allCityBoundaries.push({
                                    name: provinceName,
                                    polygon: polygon
                                });
                            }
                        }
                        console.log(`✅ ${provinceName} 边界加载完成`);
                    }
                });
            });
        },
        showFullSwiper() {
            this.$emit('showFullSwiper');
        },
        getOptions(echartType, obj) {
            switch (echartType) {
                case 'drop':
                    let dropoption = getCharts.getDropEchart(obj);
                    return dropoption;
                    break;
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj);
                    return baseoption;
                    break;
                default:
                    break;
            }
        },

        // 最新资讯跳转
        toNewsDetail(id) {
            let href = 'http://data.youcaiyun.com/page/detail?module=4&type=3&id=0&bId=' + id
            window.open(href, this.isScreen ? '_self' : '_blank');
        },
        // 热力图交互
        onHotmap(item) {
            this.activeCity = item.CityName
            this.map.centerAndZoom(item.CityName, 10);
        },
        // 测试热力图 - 使用模拟数据
        testHeatmapWithMockData() {
            console.log('🔥 开始测试热力图渲染 - 使用模拟数据');

            // 模拟真实的全国主要城市数据
            const mockData = [
                { CityName: '北京', CityCaption: '北京市', lng: 116.4074, lat: 39.9042, count: 156 },
                { CityName: '上海', CityCaption: '上海市', lng: 121.4737, lat: 31.2304, count: 198 },
                { CityName: '广州', CityCaption: '广州市', lng: 113.2644, lat: 23.1291, count: 145 },
                { CityName: '深圳', CityCaption: '深圳市', lng: 114.0579, lat: 22.5431, count: 178 },
                { CityName: '成都', CityCaption: '成都市', lng: 104.0668, lat: 30.5728, count: 123 },
                { CityName: '杭州', CityCaption: '杭州市', lng: 120.1551, lat: 30.2741, count: 134 },
                { CityName: '重庆', CityCaption: '重庆市', lng: 106.5516, lat: 29.5630, count: 112 },
                { CityName: '武汉', CityCaption: '武汉市', lng: 114.3055, lat: 30.5931, count: 98 },
                { CityName: '西安', CityCaption: '西安市', lng: 108.9398, lat: 34.3416, count: 87 },
                { CityName: '天津', CityCaption: '天津市', lng: 117.2010, lat: 39.0842, count: 95 },
                { CityName: '南京', CityCaption: '南京市', lng: 118.7969, lat: 32.0603, count: 89 },
                { CityName: '苏州', CityCaption: '苏州市', lng: 120.5954, lat: 31.2989, count: 102 },
                { CityName: '郑州', CityCaption: '郑州市', lng: 113.6254, lat: 34.7466, count: 76 },
                { CityName: '长沙', CityCaption: '长沙市', lng: 112.9388, lat: 28.2282, count: 68 },
                { CityName: '沈阳', CityCaption: '沈阳市', lng: 123.4315, lat: 41.8057, count: 54 },
                { CityName: '青岛', CityCaption: '青岛市', lng: 120.3826, lat: 36.0671, count: 72 },
                { CityName: '厦门', CityCaption: '厦门市', lng: 118.0894, lat: 24.4798, count: 65 },
                { CityName: '大连', CityCaption: '大连市', lng: 121.6147, lat: 38.9140, count: 58 },
                { CityName: '昆明', CityCaption: '昆明市', lng: 102.8329, lat: 24.8801, count: 45 },
                { CityName: '合肥', CityCaption: '合肥市', lng: 117.2272, lat: 31.8206, count: 62 }
            ];

            this.spreadLoading = false;
            this.companyHomeSpreadData = mockData;

            let arr = mockData.map(item => item.count);
            let max = Math.max(...arr);

            console.log('📊 模拟数据统计:', {
                城市数量: mockData.length,
                最大值: max,
                最小值: Math.min(...arr),
                数据范围: `${Math.min(...arr)} - ${max}`
            });

            if (this.view && typeof mapvgl !== 'undefined') {
                // 移除旧的热力图层
                if (this.heatmapLayer) {
                    this.view.removeLayer(this.heatmapLayer);
                }

                // 转换数据格式为 MapVGL 需要的格式
                const heatmapData = mockData.map(item => ({
                    geometry: {
                        type: 'Point',
                        coordinates: [item.lng, item.lat]
                    },
                    properties: {
                        count: item.count
                    }
                }));

                console.log('🗺️ 热力图数据格式:', heatmapData.slice(0, 2));
                console.log('🗺️ 测试坐标 - 郑州:', { lng: 113.6254, lat: 34.7466 });

                // 创建热力图层 - 调整参数使位置对齐
                this.heatmapLayer = new mapvgl.HeatmapLayer({
                    size: 80000, // 增大热力图范围，使其更明显
                    max: max,
                    unit: 'm',
                    height: 0,
                    gradient: {
                        0.0: 'rgba(0, 0, 255, 0)',
                        0.3: 'rgba(0, 150, 255, 0.6)',
                        0.5: 'rgba(0, 255, 255, 0.8)',
                        0.7: 'rgba(0, 255, 0, 1)',
                        0.85: 'rgba(255, 255, 0, 1)',
                        1.0: 'rgba(255, 0, 0, 1)'
                    }
                });

                this.view.addLayer(this.heatmapLayer);
                this.heatmapLayer.setData(heatmapData);

                // 添加城市标记点，让热力图更明显
                this.addCityMarkers(mockData);

                console.log('✅ 热力图渲染完成！图层颜色说明:');
                console.log('  🔵 蓝色 -> 🔷 青色 -> 🟢 绿色 -> 🟡 黄色 -> 🔴 红色');
                console.log('  数值越大，颜色越偏向红色(热度越高)');
                console.log('  热力图大小: 80km 半径');
            } else {
                console.error('❌ MapVGL view 未初始化');
            }
        },
        // 添加有数据城市的高亮边界和标记
        addCityMarkers(cityData) {
            // 清除旧的高亮标记
            if (this.cityMarkers && this.cityMarkers.length > 0) {
                this.cityMarkers.forEach(marker => {
                    this.map.removeOverlay(marker);
                });
            }
            this.cityMarkers = [];

            cityData.forEach(city => {
                const point = new BMapGL.Point(city.lng, city.lat);

                // 获取并绘制有数据城市的高亮边界
                const boundary = new BMapGL.Boundary();
                boundary.get(city.CityName + '市', (rs) => {
                    if (rs.boundaries && rs.boundaries.length > 0) {
                        const boundaries = rs.boundaries;

                        for (let i = 0; i < boundaries.length; i++) {
                            const points = [];
                            const coords = boundaries[i].split(';');

                            coords.forEach(coord => {
                                if (coord) {
                                    const [lng, lat] = coord.split(',').map(Number);
                                    if (!isNaN(lng) && !isNaN(lat)) {
                                        points.push(new BMapGL.Point(lng, lat));
                                    }
                                }
                            });

                            if (points.length > 0) {
                                // 创建有数据城市的高亮边界 - 青色高亮
                                const polygon = new BMapGL.Polygon(points, {
                                    strokeColor: '#00FFFF',
                                    strokeWeight: 3,
                                    strokeOpacity: 1,
                                    fillColor: '#00FFFF',
                                    fillOpacity: 0.15
                                });

                                this.map.addOverlay(polygon);
                                this.cityMarkers.push(polygon);
                            }
                        }

                        console.log(`✅ 已绘制 ${city.CityName} 的高亮边界（有数据）`);
                    } else {
                        console.warn(`⚠️ 未找到 ${city.CityName} 的边界数据`);
                    }
                });

                // 添加文字标签
                const label = new BMapGL.Label(city.CityName + '\n' + city.count, {
                    position: point,
                    offset: new BMapGL.Size(10, -10)
                });

                label.setStyle({
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    border: '2px solid #00FFFF',
                    borderRadius: '4px',
                    padding: '6px 10px',
                    whiteSpace: 'pre',
                    textAlign: 'center'
                });

                this.map.addOverlay(label);
                this.cityMarkers.push(label);
            });

            console.log(`✅ 已添加 ${cityData.length} 个有数据城市的高亮边界和标签`);
        },
        getRefreshData() {
            this.spreadLoading = this.parBuildLoading = this.parProjectLoading = this.countMoneyLoading = true
            const parmas = { year: this.currentYear };

            // 根据 useTestData 控制使用测试数据还是真实接口
            if (this.useTestData) {
                // 🔥 测试模式：使用模拟数据
                console.log('📌 当前使用测试数据模式');
                this.testHeatmapWithMockData();
            } else {
                // 📡 生产模式：使用真实接口
                console.log('📌 当前使用真实接口数据模式');
                // 企业中标分布（热力图）- 真实 API 调用
                ajaxService.getCompanyHomeSpread(parmas).then(res => {
                    // console.log('热力图',res)
                    this.spreadLoading = false
                    if (!res.ErrorCode) {
                        this.companyHomeSpreadData = res.Data;
                        let arr = []
                        if (res.Data && res.Data.length) {
                            res.Data.forEach(item => {
                                arr.push(item.count)
                            })
                        }
                        // 画热力图
                        let max = this.$UtilTool.calMax2(arr)

                        if (this.view && typeof mapvgl !== 'undefined') {
                            // 移除旧的热力图层
                            if (this.heatmapLayer) {
                                this.view.removeLayer(this.heatmapLayer);
                            }

                            // 转换数据格式为 MapVGL 需要的格式
                            const heatmapData = this.companyHomeSpreadData.map(item => ({
                                geometry: {
                                    type: 'Point',
                                    coordinates: [item.lng, item.lat]
                                },
                                properties: {
                                    count: item.count
                                }
                            }));

                            // 创建热力图层
                            this.heatmapLayer = new mapvgl.HeatmapLayer({
                                size: 50000,
                                max: max,
                                unit: 'm',
                                height: 0,
                                gradient: {
                                    0.0: 'rgba(0, 0, 255, 0)',
                                    0.5: 'rgba(0, 255, 255, 1)',
                                    0.7: 'rgba(0, 255, 0, 1)',
                                    0.9: 'rgba(255, 255, 0, 1)',
                                    1.0: 'rgba(255, 0, 0, 1)'
                                }
                            });

                            this.view.addLayer(this.heatmapLayer);
                            this.heatmapLayer.setData(heatmapData);
                        } else {
                            console.warn('MapVGL view not initialized');
                        }
                    }
                });
            }

            // 我的战略伙伴开工建面
            ajaxService.getPartnerBuild(parmas).then(res => {
                // console.log('我的战略伙伴开工建面',res)
                this.parBuildLoading = false
                if (!res.ErrorCode) {
                    this.partnerBuildData = res.Data;
                }
            });

            // 落地合作项目占比TOP10
            ajaxService.getCompanyPartnerProject(parmas).then(res => {
                // console.log('落地合作项目占比TOP10',res)
                this.parProjectLoading = false
                if (!res.ErrorCode) {
                    this.partnerProjectData = res.Data;
                    if (res.Data && res.Data.aList) {
                        // let cloneArr = JSON.parse(JSON.stringify(res.Data.aList))
                        // this.maxProjectItem = cloneArr.reduce((a,b) => Number(a.iThisCoverCnt) >= Number(b.iThisCoverCnt) ? a : b )
                        const maxProjectItem = res.Data.aList.reduce((a, b) => Number(a.iThisCoverCnt) >= Number(b.iThisCoverCnt) ? a : b)
                        this.maxProjectValue = maxProjectItem.iThisCoverCnt || 0
                    }
                }
            });

            // 当年企业中标项目数量，销售额 还有环比（折柱图）
            ajaxService.getRecentYearCountAndTotalSale(parmas).then(res => {
                // console.log('折柱图',res)
                this.countMoneyLoading = false
                if (!res.ErrorCode) {
                    this.countMoneyHead = res.Data.AreaAndCount
                    this.countMoneyChart = res.Data.aProject
                }
            });
        },
        getInitData() {
            this.newsLoading = this.coverLoading = true
            this.getRefreshData();
            // 企业logo
            ajaxService.getCompanyLogo().then(res => {
                // console.log('企业logo',res)
                if (!res.ErrorCode) {
                    this.logo = res.Data.Logo;
                }
            });

            // 百强房企合作占比（水滴图）
            ajaxService.getCompanyPartnerCover().then(res => {
                // console.log('水滴图',res)
                this.coverLoading = false
                if (!res.ErrorCode) {
                    this.companyPartnerCoverData = res.Data;
                }
            });

            // 获取合作伙伴动态列表
            ajaxService.getCompanyPartnerNew().then(res => {
                // console.log('合作伙伴动态列表',res)
                this.newsLoading = false
                if (!res.ErrorCode) {
                    this.partnerNewList = res.Data.aList;
                    this.partnerNewListCount = res.Data.count;
                }
            });

        },
        changeYear() {
            this.getRefreshData();
        }
    },
}
</script>
<style lang="scss" scoped>
@use '../../assets/styles/mixin' as *;

.fullscreen {
    .main {
        .main--middle {
            width: 54.8vw
        }

        ;

        .main--right {
            width: 20vw
        }

        ;
    }
}

.menu {
    background-image: url('../../assets/imgs/menu_report.png');
}

.year_select_box {
    position: absolute;
    right: 5.8vw; // 4.6
    bottom: 0.54vh;
    display: flex;
    align-items: flex-end;
    height: 40px; // 46 23
    width: 2.73rem; // 182 91
    max-width: 182px;

    ::v-deep {
        .el-input__inner {
            background-color: rgba(23, 45, 80, .65);
            border-color: #9E7D82;
            color: #fff;
            font-size: 16px;
            border-radius: 40px;
            height: 40px;
            padding-left: 22px;
            line-height: 40px;
        }

        .el-input__suffix {
            right: 15px;
        }

        .el-select__caret {
            color: #FCE5BC;
        }

        .el-input.is-focus .el-input__inner {
            border-color: #9E7D82;
        }
    }
}

::v-deep .el-select-dropdown__wrap {
    background-color: rgba(23, 45, 80, .65);
}

::v-deep .year_select_dropdown {
    background-color: rgba(23, 45, 80, .65);
}

header {
    height: 10vh;
    box-sizing: border-box;
    padding-top: 2.4vh;
    position: relative;

    .logo--company {
        width: 1.02rem;
        height: .66rem;
        border: .03rem solid #FBE7BF;
        border-radius: .03rem;
        background: rgba($color: #FCD6BE, $alpha: .37);
        box-sizing: border-box;
        padding: .07rem;

        .pic {
            width: 100%;
            height: 100%;
            background: #00A1FF;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .title {
        font-size: .4rem;
        font-weight: bold;
        color: #FCE5BC;
    }
}

.box_normal {
    border: .02rem solid rgba($color: #1F1C50, $alpha: 0.5);
    background-color: rgba($color: #010b10, $alpha: 0.2);

    &.special {
        background-color: rgba($color: #010b10, $alpha: 0.35);

        .progressbarList .item {
            height: 3.2vh;
        }

        .progressbarList .item .valueBar {
            height: 35%;
        }

        .progressbarList .item .value {
            min-width: 60px;
        }
    }
}

.box_chart--doubleLine {
    border: none;
    background: none;
    height: 27.4vh;

    .detailBox {
        text-align: center;

        .item {
            float: none;
            display: inline-block;

            .label {
                font-size: .2rem;
            }
        }
    }
}

.box_map {
    background: none;
    border: none;
}

.h_left_top {
    height: 53.5vh;
}

.h_left_bottom {
    height: 28.5vh;
}

.h_right_top {
    height: 40vh;
}

.h_right_bottom {
    height: 42.4vh;
}

.mapTitle {
    width: 100%;
    height: .48rem;
    line-height: .48rem;
    font-size: .2rem;
    font-weight: bold;
    background: url('../../assets/imgs/report_mapTitle.png') 0 0 no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    color: white;
    text-align: center;
}

.box_partner_wrap {
    .swiper-slide {
        &:nth-child(2n) {
            .box_partner {
                .item {
                    border-bottom: none;
                }
            }
        }
    }
}

.box_partner {
    width: 100%;
    // height: 32vh;
    height: 16vh;
    box-sizing: border-box;
    padding: 0 .2rem;

    .item {
        box-sizing: border-box;
        border-bottom: .01rem solid #03EDFF;
        // height: 48%;
        height: 98%;
        color: white;
        line-height: 2;
        padding-top: .1rem;

        // &:last-child{
        //     border-bottom: none;
        // }
        .title {
            font-size: .18rem;
        }

        .con {
            font-size: .16rem;
            @include text_clamp(2);
        }

        .footer {
            .tipBtn {
                // width: .56rem;
                // height: .3rem;
                // background: url('../../assets/imgs/btn.png') 0 0 no-repeat;
                // background-size: 100% 100%;
                line-height: .3rem;
                text-align: center;
                color: white;
                font-size: .14rem;

                background-color: rgba($color: #086e8c, $alpha: 0.6);
                border: .01rem solid rgba($color: #00e4e5, $alpha: 0.6);
                border-radius: .04rem;
                padding: 0 .05rem;
            }
        }
    }
}

.box_partner_footer {
    box-sizing: border-box;
    padding: 0 .2rem;
    text-align: center;
    position: relative;
    font-size: .14rem;
    color: white;

    .icon_l,
    .icon_r {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: #00FFFF;
        font-weight: bold;
        outline: none;

        &.disabled {
            color: #ADAFB2;
        }
    }

    .icon_l {
        left: .2rem;
    }

    .icon_r {
        right: .2rem;
    }
}

.partnerMain_left {
    height: 47vh;
}

.partnerMain_right {
    height: 33vh;
}


.subscript {

    &::after,
    &::before {
        border: .01rem solid rgba($color: #42B7F4, $alpha: 1);
    }

    // 位置
    &.right_bottom {

        //右下角
        &::after {
            right: -.01rem;
            bottom: -.01rem;
            border-left: none;
            border-top: none;
            display: block;
        }
    }

    &.left_top {

        //左上角
        &::before {
            left: -.01rem;
            top: -.01rem;
            border-right: none;
            border-bottom: none;
            display: block;
        }
    }
}

.progressbarList {
    .item {
        .valueBar {
            background: #302630;
            margin: 0 6px;

            .innerBar {

                // 带分割线
                .innerSplit {
                    background: url('../../assets/imgs/land_bar_split2.png') 0 0 repeat-x;
                    background-size: .12rem 100%;
                }
            }
        }

        .label {
            min-width: 50px;
        }
    }
}

.hotmapList {
    background: rgba($color: #0b163b, $alpha: 0.9)
}
</style>
